import { render, staticRenderFns } from "./EmbedMyAppointments.vue?vue&type=template&id=7d7a1357&"
import script from "./EmbedMyAppointments.vue?vue&type=script&lang=js&"
export * from "./EmbedMyAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports